import { useTranslation } from "@msuite/ui/localization";
import type * as Types from "@msuite/utils/types";
import { UserCard } from "@/components/cards";

/** Props Interface */
interface UserTimelineAuditInsertItemProps {
	item: Types.UserTimelineAuditInsertItem;
}

export function UserTimelineAuditInsertItem({ item }: UserTimelineAuditInsertItemProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="h-stack card">
			<UserCard
				userId={item.userId}
				variant="plain"
				fontSize="md"
			/>
			<p className="-ml-1">{t("users.signed_up")}.</p>
		</div>
	);
}
